import React from 'react'
import {reduxForm} from 'redux-form'
import styles from './b2bCompany.scss'
import Input from '../input'
import {find} from 'lodash/collection'
import {trimObject, hasContent} from 'lib/helpers'
import ClientProfileForm from '../clients/clientProfileForm'
import cs from 'classnames'

import i18n from 'lib/i18n'
const _ = i18n('b2bCompany')

const fieldType = {
	name: 'multiple',
	dateOfBirth: 'multiple',
	street: 'multiple',
	postalCode: 'multiple',
	email: 'multiple',
	phoneNumber: 'multiple',
	contractNumber: 'unique',
	clientNumber: 'unique',
	claimNumber: 'unique',
	licencePlate: "unique",
	companyRegistrationNumber: "multiple",
	myEasinsure: "multiple",
	needsAnalysis: "multiple",
	clientFile: "multiple",
}

const validate = values => {
	const errors = {}
	const formattedData = trimObject(values)
	const isEmpty = !hasContent(formattedData)
	if (isEmpty) {
		errors._error = 'emptyFields'
	}
	return errors
}

@reduxForm({
	form: "clients",
	fields: Object.keys(fieldType),
	error: React.PropTypes.string,
	validate,
})
export default class SearchClientsForm extends React.Component {
	render() {
		const columns = [
			[
				'name',
				'dateOfBirth',
				'street',
				'postalCode',
				'email',
				'phoneNumber',
			],
			[

				'contractNumber',
				'clientNumber',
				'claimNumber',
				'licencePlate',
				'companyRegistrationNumber',
				'myEasinsure',
				'needsAnalysis',
				'clientFile',
			],
		]
		const isTernary = {
			myEasinsure: true,
			needsAnalysis: true,
			clientFile: true,
		}

		const {fields, fields: {state}, handleSubmit, error, createClientAccess, openModal, modalState} = this.props
		const usedField = find(fields, field => field.value)
		const usedType = usedField && fieldType[usedField.name]
		const invalid = error === 'emptyFields'

		return (
			<div>
				<form onSubmit={handleSubmit} name="clientSearchForm" className={`clientSearchForm`}>
					<div className={styles.formContainer}>
						{columns.map((col, i) =>
							<div key={i} className={styles.column}>
								{col.map((name) =>
									<div key={name} className={styles.searchContainer}>
										<div className={styles.label}>
											{_(name)}
										</div>
										<div className={styles.clientSearchInput}>
											<Input
												autoFocus={name === 'name'}
												disabled={usedType ? usedField.name !== name && (usedType === 'unique' ? true : (usedType !== fieldType[name])) : false}
												type={isTernary[name] ? "ternary" : "text"}
												{...fields[name]}
											/>
										</div>
									</div>
								)}
							</div>
						)}
					</div>
					<div className={styles.formContainer}>
						<span className={styles.column}>
							<span className={styles.searchContainer}>
								<span className={cs(styles.clientSearchButtonContainer, styles.left)}>
									<button
										className={styles.greyButton}
										disabled={invalid}
										onClick={handleSubmit}
										type="submit"
									>
										{_('submitbutton')}
									</button>
                                    {createClientAccess && <button className={`${styles.greyButton} btn`} onClick={e => openModal(e)}>{_('create-profile')}</button>}
								</span>
							</span>
                        </span>
						<span className={styles.column}/>
					</div>
				</form>
                {modalState && <div className={styles.overlayMap}></div>}
				<div className={cs(
                    styles.customCreateModal,
                    modalState === true && styles.isOpened
                )}>
                    {modalState && <ClientProfileForm openModal={openModal} />}
				</div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/b2bCompany/b2bCompanySearchClientsForm.jsx